export const levelColors = ['red', 'orange', 'amber', 'green', 'indigo']
